import type { PageType } from '@sortlist-frontend/tracking';

export const getPageTypeFromPathname = (
  pathname: string,
): Extract<PageType, 'homepage' | 'longtail' | 'agency-profile'> => {
  if (pathname === '/') {
    return 'homepage';
  }

  if (pathname.startsWith('/agency/')) {
    return 'agency-profile';
  }

  return 'longtail';
};
